import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

interface DriverModalProps {
  isOpen: boolean;
  toggle: () => void;
  selectedDriver: string;
  setSelectedDriver: (status: string) => void;
  ordersListDriver: { id: string; name: string }[];
  handleDriverUpdate: () => void;
}

const DeliveryDriverAllocateOrder: React.FC<DriverModalProps> = ({
  isOpen,
  toggle,
  selectedDriver,
  setSelectedDriver,
  ordersListDriver,
  handleDriverUpdate,
}) => {
  console.log("ordersListDriver", ordersListDriver)
  console.log("selectedDriver", selectedDriver)
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Update Driver </ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <label className="form-label" htmlFor="status-select">
          Select Driver
          </label>
          <select
            className="form-control"
            id="status-select"
            name="Driver"
            onChange={(e) => setSelectedDriver(e.target.value)}
            value={selectedDriver}
          >
            <option value="">Select Driver</option>
            {ordersListDriver.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Discard
        </Button>
        <Button color="primary" onClick={handleDriverUpdate}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeliveryDriverAllocateOrder;
